import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketDivider } from '@market/react';
import { getLegalUrls } from 'typescript/utilities/links';

interface DisclaimerProps extends HTMLAttributes<HTMLElement> {
  applicationFlowToken?: string;
  disclosureDocumentToken?: string;
  showDivider?: boolean;
}

const Disclaimer = ({
  className = '',
  applicationFlowToken = null,
  showDivider = true,
}: DisclaimerProps) => {
  const { t } = useTranslation();

  const legalUrls = getLegalUrls(applicationFlowToken);

  const disclaimerText = (): string =>
    t('checkout.payment_v3.payInFull.disclaimer', legalUrls);

  return (
    <div className={className}>
      {showDivider && (
        <div className="shop-grid-item-full">
          <MarketDivider size="thin" />
        </div>
      )}
      <p className={`shop-grid-item-full paragraph-20`}>
        <div dangerouslySetInnerHTML={{ __html: disclaimerText() }} />
      </p>
    </div>
  );
};

export default Disclaimer;
